import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ListingPublic, ListingVariationPublic } from "../../../../globalTypes/listings.types";
import { DisplayListingsComponent } from "./display-listing.component";
import { MatIcon } from "@angular/material/icon";

export interface SearchListingPopupData {
  listing: ListingPublic
}

@Component({
  selector: 'msh-search-listing-popup',
  template:`
  @if(data.listing && data.listing.id){
    <msh-display-listings 
      [inPopup]="true" 
      class="bg-back border" 
      [listingId]="data.listing.id || ''"
      (onActionTaken)="onActionTaken($event)"
    ></msh-display-listings>  
    <div
      (click)="dialogRef.close()"
      class="absolute right-0 top-0 bg-transparent rounded-full 
            w-10 h-10 flex items-center justify-center hover:bg-copy/15 transition cursor-pointer"
    >
      <mat-icon class="text-copy">close</mat-icon>
    </div>  
  }
  `,
  imports: [DisplayListingsComponent, MatIcon],
})
export class SearchListingPopupDialog {
  constructor(
    public dialogRef: MatDialogRef<SearchListingPopupDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SearchListingPopupData,
  ){}
  onActionTaken(event: string){
    console.log({event});
    this.dialogRef.close();
  }
}